import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
import {
  getDownloadURL,
  ref as stgRef,
  uploadBytesResumable,
} from "firebase/storage";
import { useNavigate } from "react-router-dom";
import { auth, db, storage } from "../../../../firebaseConfig";
import { ref, set } from "firebase/database";
import { createUserWithEmailAndPassword } from "firebase/auth";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useEffect, useState } from "react";
import "./AddTherapist.css";

export default function AddTherapist({ setIsAddTherapist }) {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [workEmail, setWorkEmail] = useState("");
  const [name, setName] = useState("");
  const [bioText, setBioText] = useState("");
  const [password, setPassword] = useState("");
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [therapistPhoto, setTherapistphoto] = useState(null);
  const [therapistCalendlyLink, setTherapistCalendlyLink] = useState("");
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (name.length > 0) {
      setWorkEmail(`${name?.split(" ")[0]}@vibesandvent.org`);
    }
  }, [name]);

  const onSignInUser = () => {
    setIsSigningIn(true);
    createUserWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
        // Signed up
        const user = userCredential.user;
        // console.log(user);
        if (user) {
          if (therapistPhoto) {
            console.log("YES IMAGE");
            const response = await fetch(therapistPhoto);
            const blob = await response.blob();
            const photoFileName = `therapist_photo_${user?.uid}.jpg`;
            const photoRef = stgRef(
              storage,
              `therapist_photos/${photoFileName}`
            );
            const uploadTask = uploadBytesResumable(photoRef, blob);
            uploadTask.on(
              "state_changed",
              (snapshot) => {
                const progress_ =
                  snapshot.bytesTransferred / snapshot.totalBytes;
                setProgress((progress_ * 100).toFixed());
                console.log(progress_);
              },
              (error) => {
                // handle error
                alert("Ooops, there was a problem uploading your photo");
                console.log(error);
                console.error("Upload error:", error);
              },
              () => {
                getDownloadURL(uploadTask.snapshot.ref)
                  .then(async (downloadURL) => {
                    // console.log(downloadURL);

                    // Update display name in Firebase Realtime Database
                    const userRef = ref(db, `therapists/${user?.uid}`);
                    await AsyncStorage.setItem("@user", JSON.stringify(user));
                    set(userRef, {
                      displayName: `${name}  `,
                      uid: user?.uid,
                      email: email,
                      bio: bioText || "",
                      workEmail: workEmail || "",
                      calendlyLink:
                        therapistCalendlyLink ||
                        "https://calendly.com/vibesandvent/30min",
                      photoURL: downloadURL,
                    })
                      .then(() => {
                        // Photo successfully added
                        console.log("Photo uploaded successfully!");
                      })
                      .catch((error) => {
                        // Handle the error
                        alert("Error uploading photo");
                        console.error("Error uploading photo: ", error);
                      });
                    setIsSigningIn(false);
                    setIsAddTherapist(false);
                    setName("");
                    setEmail("");
                    setPassword("");
                    navigate("/therapists");
                  })
                  .catch((error) => {
                    alert("Error getting download URL: ", error);
                    console.error("Error getting download URL:", error);
                  });
              }
            );
          } else {
            // Update display name in Firebase Realtime Database
            const userRef = ref(db, `therapists/${user?.uid}`);
            await AsyncStorage.setItem("@user", JSON.stringify(user));
            set(userRef, {
              displayName: `${name}  `,
              uid: user?.uid,
              email: email,
              bio: bioText || "",
              workEmail: workEmail || "",
              calendlyLink:
                therapistCalendlyLink ||
                "https://calendly.com/vibesandvent/30min",
            });

            setIsSigningIn(false);
            setIsAddTherapist(false);
            setName("");
            setEmail("");
            setPassword("");
            navigate("/therapists");
          }
        }
      })
      .catch((error) => {
        setIsSigningIn(false);

        const errorCode = error.code; // Move this line above the if statement

        if (errorCode === "auth/email-already-in-use") {
          alert("The therapist already exists");
        } else {
          alert(error.message); // Display other error messages to the user
        }

        console.log(errorCode + ": " + error.message);
      });
  };

  let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;

  const onSetTherapist = async () => {
    if (name.length > 0) {
      if (email.length > 0 && reg.test(email)) {
        if (password.length > 6) {
          try {
            onSignInUser();

            // onswitch;
          } catch (error) {
            // Handle the error, e.g., log it or show an error message to the user?.
            alert("Oops, a problem occurred");
            console.error("Error updating name:", error);
          }
        } else {
          alert("Use at least more than 6 characters for the password!");
        }
      } else {
        alert("invalid email");
      }
    } else {
      alert("You have to input name");
    }
  };

  return (
    <div className="add-therapist">
      <div className="add-therapist-container">
        {therapistPhoto ? (
          <img
            src={therapistPhoto}
            className="profile-img"
            alt={`${therapistPhoto}`}
          />
        ) : (
          <div className="profile-div">
            <h3 style={{ color: "#d3d3d3", textAlign: "center" }}>
              Click below to upload a photo
            </h3>
            <PanToolAltIcon
              style={{
                color: "#d3d3d3",
                fontSize: 42,
                transform: "rotate(180deg)",
              }}
            />
          </div>
        )}
        <input
          className="add-profile"
          type="file"
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) {
              const reader = new FileReader();
              reader.onloadend = () => {
                setTherapistphoto(reader.result);
              };
              reader.readAsDataURL(file);
            }
          }}
        />
        <input
          placeholder="Therapist's full name"
          value={name}
          type={"text"}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <div className="emails">
          <input
            placeholder="Enter Therapist's email"
            type={"email"}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            placeholder="Therapist's Work email"
            type={"email"}
            value={workEmail}
            onChange={(e) => setWorkEmail(e.target.value)}
          />
        </div>
        <input
          placeholder="Therapist's Calendly link"
          type={"url"}
          value={therapistCalendlyLink}
          onChange={(e) => setTherapistCalendlyLink(e.target.value)}
        />
        <textarea
          placeholder="Therapist's bio"
          value={bioText}
          rows={8}
          onChange={(e) => setBioText(e.target.value)}
        ></textarea>
        <input
          placeholder="Password"
          type={"password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button
          className="submit-btn"
          style={isSigningIn ? { backgroundColor: "#071c2e6b" } : {}}
          disabled={isSigningIn}
          onClick={() => onSetTherapist()}
        >
          {isSigningIn ? `Uploading ${progress}%...` : "Add"}
        </button>
        {!isSigningIn && (
          <button
            className="cancel-btn"
            onClick={() => setIsAddTherapist(false)}
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  );
}
